import React, { useEffect, useState } from 'react';
import { AlertTriangle, Clock } from 'lucide-react';
import { Section } from './Shared';
import { FeatherQuill, MoonPhase } from './HealingIcons';
import { Pricing } from './Pricing';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 22,
    m: 21,
    s: 59
  });
  const [spotsTaken] = useState(94);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-245" data-mp="1wtfk5sylb5h5">
      <div className="bg-brand-purple text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums border border-brand-purpleLight/40" data-id="element-246" data-mp="1wqjm84mqsgsp">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-sm font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-247" data-mp="25k2ae0o4gmdl">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-248" data-mp="2fjjfogzgoy91">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-purple/40 bg-gradient-to-br from-white/95 to-brand-purpleLight/10 shadow-[0_10px_40px_rgba(23,61,31,0.12)]" data-id="element-249" data-mp="2fii0q1fbrrm1">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-250" data-mp="2pa5s62bvt8ni">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-purple shrink-0" data-id="element-251" data-mp="2tb7qmgxz5gof" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-purpleDark text-center" data-id="element-252" data-mp="2y9sseksvk8ez">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-253" data-mp="336rkyyww47b2">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-254" data-mp="1375swyudv815" />
          <span className="text-2xl md:text-4xl font-bold text-brand-purple/60 pb-5" data-id="element-255" data-mp="y7t5abvotwxi">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Minutos" data-id="element-256" data-mp="1cwpc65m0d3wj" />
          <span className="text-2xl md:text-4xl font-bold text-brand-purple/60 pb-5" data-id="element-257" data-mp="1cy8wq8ep6144">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Segundos" data-id="element-258" data-mp="1lwu91ltksjwg" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-brand-goldLight/30 border border-brand-gold/50 rounded-xl px-4 py-3 mb-6" data-id="element-259" data-mp="1lz6zyohba4ln">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-brand-goldDark shrink-0" data-id="element-260" data-mp="1vvtk1b1tcrmm" />
          <p className="text-sm md:text-base font-semibold text-brand-purpleDark text-center" data-id="element-261" data-mp="1qwgq66ciykaj">
            Después sube a US$25.{' '}
            <span className="text-brand-burgundy" data-id="element-262" data-mp="1i245tsw5biq">No vuelve.</span>
          </p>
        </div>

        <div className="bg-white/80 rounded-2xl p-4 md:p-5 border border-brand-purple/30" data-id="element-263" data-mp="3solkfohhxtof">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-264" data-mp="286kj2w6w74hc">
            <div className="flex items-center gap-2" data-id="element-265" data-mp="2d3krvev4mlc5">
              <span className="relative flex h-2.5 w-2.5" data-id="element-266" data-mp="1yfpwtrtnc4vw">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-burgundy opacity-75" data-id="element-267" data-mp="1yf6ql8dcz4xp"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-burgundy" data-id="element-268" data-mp="23cgbcapsysf7"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-269" data-mp="1uduucjzzblgj">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-purple uppercase tracking-wide" data-id="element-270" data-mp="1fiyeplpubvtf">
              Quedan muy pocos
            </span>
          </div>

          <div className="w-full bg-brand-purple/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-271" data-mp="39w6dtpkumtkv">
            <div className="bg-gradient-to-r from-brand-purple to-brand-purpleDark h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-272" data-mp="3esojqsrx0xys" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-273" data-mp="15qiozelpogq2">
            <strong className="text-brand-purple" data-id="element-274" data-mp="15sv1vdcm40w9">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
type Volume = {
  title: string;
  meta: string;
  intro: string;
  features: string[];
  plants?: string;
  closing: string;
  image: string;
  wrapper: string;
  titleColor: string;
  boxBorder: string;
  protocols?: {
    sys: string;
    cond: string;
  }[];
  protocolsNote?: string;
};
const volumes: Volume[] = [{
  title: 'VOLUMEN I — ENCICLOPEDIA GLOBAL DE FITOTERAPIA A-L',
  meta: '50 fichas técnicas · basado en monografías OMS, EMA y Commission E alemana',
  intro: 'La primera enciclopedia clínica de plantas medicinales globales creada para el terapeuta profesional de habla hispana. Desde Agrimonia hasta Llantén, cada planta documentada con respaldo científico real.',
  features: ['✅ Nombre científico y popular', '✅ Principios activos y acción farmacológica', '✅ Indicaciones terapéuticas por nivel de evidencia', '✅ Dosificación profesional por preparación', '✅ Contraindicaciones y poblaciones de riesgo', '✅ Semáforo de seguridad: verde, amarillo y rojo', '✅ Nota terapéutica clínica práctica', '✅ Referencias científicas verificables'],
  plants: 'Plantas como Ashwagandha, Boldo, Caléndula, Cardo Mariano, Cúrcuma, Equinácea, Ginkgo, Ginseng, Hipérico y Jengibre — todas con respaldo científico.',
  closing: 'Deja de buscar información dispersa en internet. Tienes todo lo que necesitas en un solo lugar, organizado y validado.',
  image: 'https://cdn.magicpatterns.com/uploads/r5x75ZwsaMMfLUoonNog6G/tomo_1.png',
  wrapper: 'bg-brand-purpleDark/15 border-brand-purpleDark/30',
  titleColor: 'text-brand-purpleDark',
  boxBorder: 'border-brand-purple/15'
}, {
  title: 'VOLUMEN II — ENCICLOPEDIA GLOBAL DE FITOTERAPIA M-Z',
  meta: '50 fichas técnicas · continuación del Volumen I',
  intro: 'Completa la enciclopedia con las 50 plantas restantes de la M a la Z. Incluye índice cruzado global por sistema del cuerpo, tabla maestra de combinaciones sinérgicas y glosario técnico completo.',
  features: ['✅ Índice cruzado global por sistema del cuerpo', '✅ Tabla maestra de combinaciones sinérgicas probadas', '✅ Glosario técnico de fitoterapia clínica'],
  plants: 'Plantas como Manzanilla, Melisa, Ortiga, Pasionaria, Rhodiola, Romero, Salvia, Schisandra, Tomillo y Valeriana.',
  closing: 'El sistema completo de consulta rápida para los 50 cuadros más frecuentes en tu práctica.',
  image: 'https://cdn.magicpatterns.com/uploads/tPAEtcoLjEyywiU4vcFJAH/tomo2.png',
  wrapper: 'bg-brand-greenMoss/20 border-brand-greenMoss/40',
  titleColor: 'text-brand-greenMoss',
  boxBorder: 'border-brand-greenMoss/15'
}, {
  title: 'VOLUMEN III — TRATADO DE PREPARACIONES Y GALÉNICA NATURAL',
  meta: '60 páginas · manual técnico profesional',
  intro: 'El manual técnico que transforma tu conocimiento herbolario en preparaciones profesionales y seguras. Parámetros exactos para cada método de extracción.',
  features: ['✅ Fundamentos de extracción vegetal', '✅ Selección de solventes según principio activo', '✅ Infusiones y decocciones con temperaturas exactas', '✅ Tinturas madre 1:5 y 1:10 paso a paso', '✅ Oleatos en frío y en caliente', '✅ Pomadas, ungüentos y bálsamos', '✅ Jarabes, elixires y tónicos medicinales', '✅ Cápsulas artesanales y gotas sublinguales', '✅ Control de calidad organoléptico', '✅ Conservación, envasado y vida útil', '✅ Etiquetado profesional'],
  closing: 'Porque no alcanza con saber qué planta usar. También tienes que saber cómo prepararla correctamente para que funcione.',
  image: 'https://cdn.magicpatterns.com/uploads/teUHX2imoWu5ynKtmXeYAf/tomo3.png',
  wrapper: 'bg-brand-amber/20 border-brand-amber/40',
  titleColor: 'text-brand-amber',
  boxBorder: 'border-brand-amber/15'
}, {
  title: 'VOLUMEN IV — CLÍNICA E INTERACCIONES MEDICAMENTOSAS',
  meta: '60 páginas · el volumen más poderoso del kit',
  intro: 'Protocolos terapéuticos listos para aplicar en tu consultorio desde el primer día. Criterio clínico puro: protocolos por sistema, dosificación adaptada por población y tabla maestra de interacciones.',
  protocols: [{
    sys: '🌿 Digestivo',
    cond: 'Gastritis, colon irritable, insuficiencia hepática'
  }, {
    sys: '🫁 Respiratorio',
    cond: 'Resfriado, gripe, bronquitis, alergias'
  }, {
    sys: '🧠 Nervioso',
    cond: 'Ansiedad, insomnio, fatiga crónica, burnout'
  }, {
    sys: '❤️ Cardiovascular',
    cond: 'Hipertensión, palpitaciones, colesterol'
  }, {
    sys: '⚖️ Endocrino y Hormonal',
    cond: 'Diabetes tipo 2, menopausia, tiroides'
  }, {
    sys: '🦴 Osteoarticular',
    cond: 'Artritis, artrosis, osteoporosis'
  }],
  protocolsNote: 'Cada protocolo incluye fórmula magistral lista para usar, dosificación para adultos, niños y adultos mayores, duración del tratamiento y criterios de derivación médica.',
  features: ['✅ Tabla maestra de interacciones planta-fármaco', '✅ Fitoterapia segura en embarazo, lactancia y pediatría', '✅ Protocolo ante reacciones adversas', '✅ Señales de alarma clínica', '✅ Checklist del terapeuta antes de prescribir', '✅ Semáforo de riesgo por tipo de paciente'],
  closing: 'Este volumen es la diferencia entre un terapeuta que conoce plantas y uno que trata pacientes con criterio clínico real.',
  image: 'https://cdn.magicpatterns.com/uploads/fk7LMViRJYE2ymeDWJ1fM5/upsell.png',
  wrapper: 'bg-brand-purple/15 border-brand-purple/40',
  titleColor: 'text-brand-purple',
  boxBorder: 'border-brand-purple/20'
}, {
  title: 'VOLUMEN V — ALQUIMIA VEGETAL Y ESPAGIRIA MODERNA',
  meta: '60 páginas · para el terapeuta que quiere ir más allá',
  intro: 'El salto del herbolario al alquimista. Para el terapeuta que ya tiene la base y quiere llevar su práctica a un nivel que muy pocos conocen.',
  features: ['✅ Historia y filosofía de la espagiria vegetal', '✅ Los tres principios alquímicos: azufre, mercurio y sal', '✅ Proceso espagírico completo: fermentación, destilación, calcinación y circulación', '✅ 8 fichas espagíricas de plantas maestras', '✅ 5 fórmulas alquímicas sinérgicas listas para usar', '✅ Fitococina terapéutica con recetas medicinales por sistema del cuerpo', '✅ Calendario anual de fitococina terapéutica', '✅ Glosario alquímico completo', '✅ Semáforo de seguridad para preparaciones avanzadas'],
  closing: 'Domina preparaciones de alta gama con respaldo técnico y abre una nueva dimensión en tu consultorio.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/8679751a-e1cc-467c-9d07-3fa100047435.jpg',
  wrapper: 'bg-brand-gold/15 border-brand-gold/50',
  titleColor: 'text-brand-goldDark',
  boxBorder: 'border-brand-gold/25'
}];
const bonuses = [{
  title: 'EL LEGAJO DE CAMPO — SISTEMA PROFESIONAL DE GESTIÓN CLÍNICA',
  pages: '30 páginas · listo para imprimir',
  color: 'text-brand-purple',
  bgColor: 'bg-brand-purple/10',
  borderColor: 'border-brand-purple/30',
  desc: 'Sistema completo de registro clínico para terapeutas de salud natural. Desde la primera consulta hasta el alta terapéutica.',
  details: ['30 planillas imprimibles para gestión completa de pacientes', 'Consentimiento informado de uso universal', 'Historia clínica, anamnesis, seguimiento y cierre terapéutico'],
  price: 'US$12'
}, {
  title: 'VADEMÉCUM GLOBAL DE FÓRMULAS FITOTERAPÉUTICAS',
  pages: '50 páginas · listo para imprimir',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  desc: '50 fórmulas magistrales concretas y listas para usar, organizadas por objetivo terapéutico. Infusiones, tinturas, cápsulas y preparados tópicos.',
  details: ['Respuesta concreta para cada cuadro clínico frecuente', 'Tabla de sustituciones y tabla de decisión rápida por sistema', 'Checklist de seguridad antes de indicar cada fórmula'],
  price: 'US$15'
}, {
  title: 'GUÍA GLOBAL DE ABASTECIMIENTO HERBOLARIO',
  pages: '30 páginas · listo para imprimir',
  color: 'text-brand-greenMoss',
  bgColor: 'bg-brand-greenLight/15',
  borderColor: 'border-brand-greenLight/40',
  desc: 'Todo lo que necesitas para conseguir materia prima de calidad, evaluarla correctamente y cosechar con criterio ético y profesional.',
  details: ['Evaluación de proveedores y control de calidad organoléptico', 'Trazabilidad básica para terapeutas', 'Cosecha ética y calendario estacional global'],
  price: 'US$10'
}];
export const MethodOverview = () => {
  return <Section id="method" className="relative" data-id="element-275" data-mp="hghs9j3hqy49">
      {/* Decorative elements */}
      <FeatherQuill className="hidden lg:block absolute top-20 right-[3%] w-8 h-8 opacity-30 animate-float-soft" color="#2F6B34" style={{
      transform: 'rotate(-15deg)'
    }} data-id="element-276" data-mp="cig9kz9z90tb" />
      <MoonPhase className="hidden lg:block absolute top-60 left-[2%] w-10 h-10 opacity-30 animate-float-soft" color="#A6D93B" style={{
      transform: 'rotate(12deg)',
      animationDelay: '1.5s'
    }} data-id="element-277" data-mp="lkpftcy7q80w" />

      <div className="text-center mb-12" data-id="element-278" data-mp="2pqplax8vl64f">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-purple/40 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-279" data-mp="2ppob0uzoonnr">
          <span className="text-xl" data-id="element-280" data-mp="2yqvx8eoxdy1h">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-purple text-sm md:text-base" data-id="element-281" data-mp="2yr5n829z0576">
            MEGAPACK SABERES ANCESTRALES™ EDICIÓN LATINOAMÉRICA
          </span>
        </div>
        <h2 className="text-2xl md:text-5xl font-display font-bold mb-4 leading-tight text-brand-purpleDark" data-id="element-282" data-mp="263jlz0o7tcnh">
          5 Volúmenes Principales + 3 Bonus Estratégicos
        </h2>
        <p className="text-brand-text/70 text-base md:text-lg" data-id="element-283" data-mp="2fz3bn5c6rf3s">
          390 páginas — Todo resuelto.
        </p>
      </div>

      <div className="max-w-5xl mx-auto mb-12 space-y-6" data-id="element-284" data-mp="2ks5zcwua7uc2">
        {volumes.map(vol => <div key={vol.title} className={`rounded-2xl p-6 md:p-8 border backdrop-blur-sm shadow-sm ${vol.wrapper}`} data-id="element-285" data-mp="1naxpce5hhi1u">
            <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-286" data-mp="1krknuv8spuxm">
              <div className="shrink-0 mx-auto md:mx-0 w-24 md:w-28" data-id="element-287" data-mp="1fs7oxc4ngxeo">
                <img src={vol.image} alt={vol.title} className="w-full aspect-[3/4] object-cover rounded-md shadow-lg ring-1 ring-brand-purple/15" data-id="element-288" data-mp="1fpv9p6qa115b" />
              </div>
              <div className="flex-grow" data-id="element-289" data-mp="11soutn8obmld">
                <h4 className={`font-serif font-bold mb-2 text-lg ${vol.titleColor}`} data-id="element-290" data-mp="11tq53phv8521">
                  {vol.title}
                </h4>
                <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-291" data-mp="s3f1y5609zw7">
                  {vol.meta}
                </p>
                <p className="text-brand-text text-sm mb-4" data-id="element-292" data-mp="n4txftjq0u1y">{vol.intro}</p>

                <div className={`bg-white/80 p-4 rounded-lg border mb-4 ${vol.boxBorder}`} data-id="element-293" data-mp="i34ocjg26qgi">
                  {vol.protocols && <>
                      <p className={`text-xs font-bold uppercase tracking-wider mb-3 ${vol.titleColor}`} data-id="element-294" data-mp="3h7ivnzra2ya">
                        Protocolos terapéuticos incluidos
                      </p>
                      <div className="space-y-2 mb-4" data-id="element-295" data-mp="3qo190b6kled2">
                        {vol.protocols.map(p => <div key={p.sys} className="flex flex-col sm:flex-row sm:items-center text-xs md:text-sm border-b border-brand-purple/10 pb-1 last:border-0 last:pb-0" data-id="element-296" data-mp="3vndyz4sqn1jv">
                            <span className="font-medium w-56 shrink-0 text-brand-text" data-id="element-297" data-mp="devhip0hfulq">
                              {p.sys}
                            </span>
                            <span className="text-brand-text/80" data-id="element-298" data-mp="164lwt1dup2jf">{p.cond}</span>
                          </div>)}
                      </div>
                      <p className="text-xs md:text-sm text-brand-text mb-4 italic" data-id="element-299" data-mp="1awdiaxi5gi2p">
                        {vol.protocolsNote}
                      </p>
                    </>}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text" data-id="element-300" data-mp="1g80r2wcouer9">
                    {vol.features.map(f => <div key={f} className="flex items-center" data-id="element-301" data-mp="1p1m6mhwog01q">
                        <span data-id="element-302" data-mp="11aqdnhghiysw">{f}</span>
                      </div>)}
                  </div>
                </div>

                {vol.plants && <p className="text-brand-text text-sm mb-4" data-id="element-303" data-mp="xbhpcs47rt4q">{vol.plants}</p>}
                <p className={`font-serif italic text-sm ${vol.titleColor}`} data-id="element-304" data-mp="1b737cfc15cnn">
                  {vol.closing}
                </p>
              </div>
            </div>
          </div>)}

        <div className="text-center mb-8 mt-12" data-id="element-305" data-mp="2hpi9y5gr4q7h">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-purpleDark" data-id="element-306" data-mp="2hoqdksfbyog5">
            🎁 3 BONUS ESTRATÉGICOS
          </h3>
          <p className="text-xs md:text-sm uppercase tracking-wider text-brand-goldDark mt-1 font-bold" data-id="element-307" data-mp="k1nveuz80z3a">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-308" data-mp="oz7naxoudadp">
          {bonuses.map((bonus, i) => {
          const numberLabel = String(i + 1).padStart(2, '0');
          return <div key={bonus.title} className="glass-panel rounded-2xl p-5 border-brand-purple/30 relative overflow-hidden bg-white/90 flex flex-col" data-id="element-309" data-mp="yq2b46hqki19" data-mpi={i}>
                <div className={`absolute top-3 left-3 ${bonus.bgColor} border ${bonus.borderColor} ${bonus.color} text-[11px] md:text-sm font-mono font-bold px-2 py-0.5 rounded-md`} data-id="element-310" data-mp="17s1pss5a3a11">
                  {numberLabel}
                </div>
                <div className="absolute top-0 right-0 bg-brand-gold text-brand-purpleDark text-xs md:text-sm font-bold px-3 py-1 rounded-bl-lg" data-id="element-311" data-mp="3eird9pr342tv">
                  GRATIS
                </div>

                <div className={`relative w-8 h-11 mt-6 mb-4 rounded-sm shadow-sm ${bonus.bgColor.replace('/10', '')} ring-1 ring-black/10 overflow-hidden`} aria-hidden="true" data-id="element-312" data-mp="3277895uvf4i2">
                  <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-black/15" data-id="element-313" data-mp="2sb44jvkdext0" />
                  <div className="absolute top-1/2 left-1 right-0.5 h-px bg-white/30" data-id="element-314" data-mp="3pwjbzq7fikcz" />
                </div>

                <h4 className="text-base font-serif font-bold mb-2 leading-tight text-brand-text" data-id="element-315" data-mp="3kyrkuyelz29u">
                  {bonus.title}
                </h4>
                <p className={`${bonus.color} text-xs font-medium mb-3`} data-id="element-316" data-mp="3bxtggf09csqq">
                  {bonus.pages}
                </p>
                <p className="text-brand-text mb-3 text-xs" data-id="element-317" data-mp="24khww5ea3fjj">{bonus.desc}</p>
                <ul className="text-xs text-brand-text/90 space-y-1.5 mb-4 flex-grow" data-id="element-318" data-mp="20hlhsony61kc">
                  {bonus.details.map(d => <li key={d} className="flex items-start" data-id="element-319" data-mp="10v7ozh2o5xr4">
                      <span className="mr-1.5 text-brand-purple shrink-0" data-id="element-320" data-mp="w2epp8pyzhmf">
                        🌿
                      </span>
                      <span data-id="element-321" data-mp="r4d3iex8z26q">{d}</span>
                    </li>)}
                </ul>
                <div className="text-xs text-brand-text/50 mt-auto" data-id="element-322" data-mp="n3t93j426coa">
                  <span data-id="element-323" data-mp="1jsr514njogn1">Valor </span>
                  <span className="line-through" data-id="element-324" data-mp="1jrpqurb8fe13">{bonus.price}</span>
                  <span className="ml-2 font-bold text-brand-goldDark" data-id="element-325" data-mp="1euh6ql6iwzx7">
                    → GRATIS con tu kit
                  </span>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-8" data-id="element-326" data-mp="15ry8kedonbha">
          <div className="inline-block glass-panel px-6 py-3 rounded-full border-brand-purple/30 bg-white/80" data-id="element-327" data-mp="3vi1v28c2s57h">
            <p className="text-sm md:text-base font-medium text-brand-text" data-id="element-328" data-mp="3qj8da3pr9s1i">
              Valor total bonos{' '}
              <span className="line-through text-brand-text/50" data-id="element-329" data-mp="261pgqwfvqpdy">US$37</span>{' '}
              <span className="text-brand-purple font-bold" data-id="element-330" data-mp="2azr9ya70s535">
                → GRATIS con tu Megapack Saberes Ancestrales
              </span>
            </p>
          </div>
        </div>
      </div>

      <LaunchUrgency data-id="element-331" data-mp="2js2ph10li84c" />

      <Pricing data-id="element-332" data-mp="2jskwmsosq6r1" />

    </Section>;
};